import { actionKey as rootActionKey } from '../constants';
export var actionKey = "".concat(rootActionKey, "__WITH_OFFSET");
//# sourceMappingURL=constants.js.map